import Popup from 'reactjs-popup'
import '../styles/viewJournals.css'

const inputStyle = {
    paddingTop: 2,
    paddingBottom: 2,
    borderBottomWidth: 3,
    borderColor: "antiquewhite",
    display: "inline",
}

const buttonGroup = ({ handleCreateBook, displayJournals, updateStateToExistingBook, setTitle, setStatus, setCurrentPage }) => {
    return <div id="button-group" className="flex">
        {/* <button className="font-semibold rounded-2xl mx-2 border-0 border-black bg-green-200 px-3 py-1 hover:bg-green-400 transition-colors" onClick={() => setCount(requestCount + 1)}>Refresh</button> */}
        <Popup trigger={<button
            onMouseEnter={() => updateStateToExistingBook({ name: "", status: "In Progress", currentPage: -1 })}
            className="focus:outline-none font-semibold rounded-2xl mx-2 border border-black px-3 py-1 hover:bg-gray-300 transition-colors"> Log a New Book</button>}
            modal>
            {close => (
                // <div class="w-screen h-screen bg-black bg-opacity-25 fixed z-999">
                <div className="h-screen w-screen w-full p-2 md:p-10 lg:p-20 bg-white">
                    <button className="close text-lg" onClick={close}>
                        &times;
                        </button>
                    <div className="">
                        <div className="mb-5 journals-title"> Create a New Book Log</div>
                        <div className="content">
                            <label className="font-light text-sm">Book Title</label><br />
                            <input
                                style={inputStyle}
                                onChange={e => setTitle(e.target.value)}
                                required className="mb-5 focus:outline-none" type="text"></input> <br />
                            <label className="font-light text-sm">Status</label><br />
                            <select
                                style={inputStyle}
                                onChange={e => setStatus(e.target.value)}
                                required className="mb-5 focus:outline-none" type="text">
                                <option >In Progress</option>
                                <option >Completed</option>
                            </select> <br />
                            <label className="font-light text-sm">Current Page</label><br />
                            <input
                                style={inputStyle}
                                onChange={e => setCurrentPage(e.target.value)}
                                required className="mb-5 focus:outline-none" type="number"></input> <br />
                            <button style={inputStyle} className="" onClick={() => { handleCreateBook(); close(); }}>Create</button>
                            <br />
                        </div>
                    </div>
                    <div className="actions">
                    </div>
                </div>
                // </div>

            )}
        </Popup>
        <Popup trigger={<button
            onMouseEnter={() => updateStateToExistingBook({ name: "", status: "In Progress", currentPage: -1 })}
            className="font-semibold rounded-2xl mx-2 border border-black px-3 py-1 
            focus:outline-none hover:bg-gray-300 transition-colors">View All Journals</button>}
            modal>
            {close => (
                // <div class="w-screen h-screen bg-black bg-opacity-25 fixed z-999">
                <div className="h-screen overflow-auto  w-screen bg-white p-2 sm:p-20 w-full">
                    <button className="close text-3xl outline-none focus:outline-none" onClick={close}>
                        &times;
                        </button>
                    <div className="journals-title mb-7">All Journals</div>
                    <div className="journals">
                        {displayJournals}
                    </div>
                </div>
                // </div>

            )}
        </Popup>
    </div>

}

export default buttonGroup